module.exports = __webpack_public_path__ + "img/same_person_title.b5f926f3.png";